// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YXpot7TwV0HpcwhqDZiy{flex-direction:column;display:flex}.anqCKFeeZt8dCYzltB6k{margin-bottom:32px}.cyuUhtLFiTY2bMtcmAGF{border-radius:12px;width:100%;height:auto;min-height:142px;margin-bottom:32px}.sVFcdzos8TFoNXGxk0Md{gap:16px;display:flex}.HO2ZE90QgBkAKGwS7Uy6{box-shadow:0 0 0 1px var(--black-20);border-radius:12px;flex-direction:column;flex:1;gap:8px;padding:16px;display:flex}.m6AJ83M_cqYMrouvzWv5{justify-content:space-between;align-items:center;gap:8px;display:flex}.rbgf52SHYp8Ot9jZAyI4{align-items:baseline;gap:4px;display:flex}.ZTqCp2Sckq01gAF0n6qz{justify-content:flex-end;gap:8px;width:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `YXpot7TwV0HpcwhqDZiy`,
	"description": `anqCKFeeZt8dCYzltB6k`,
	"banner": `cyuUhtLFiTY2bMtcmAGF`,
	"pricing": `sVFcdzos8TFoNXGxk0Md`,
	"pricingCard": `HO2ZE90QgBkAKGwS7Uy6`,
	"pricingCardHeader": `m6AJ83M_cqYMrouvzWv5`,
	"price": `rbgf52SHYp8Ot9jZAyI4`,
	"actions": `ZTqCp2Sckq01gAF0n6qz`
};
export default ___CSS_LOADER_EXPORT___;
